export class Game {
  id: string;
  name: string;
  task_alloc_policy: string;
  created_at: string;
}
